import React from 'react';
import type { PillarScores } from '../lib/platformData';
type PillarMatrixProps = {
  scores: PillarScores;
  compact?: boolean;
};
export function PillarMatrix({
  scores,
  compact = false
}: PillarMatrixProps) {
  const columns = [{
    label: 'Stock',
    value: scores.stock,
    className: 'text-[#1C1C1C]'
  }, {
    label: 'Wait',
    value: scores.wait,
    className: 'text-[#B46423]'
  }, {
    label: 'Care',
    value: scores.care,
    className: 'text-[#1C1C1C]'
  }];
  return <div className={`flex items-center justify-end space-x-5 text-center sm:space-x-6 ${compact ? 'min-w-[176px]' : 'min-w-[220px]'}`} aria-label="Pharmacy scores" data-id="element-195" data-mp="1oaa1dnospgmh">
      {columns.map(column => <div key={column.label} data-id="element-196" data-mp="1y0lb5qv5uk1a">
          <p className={`text-[10px] font-semibold uppercase tracking-wider ${column.className}`} data-id="element-197" data-mp="10k5zplv63qy4">
            {column.label}
          </p>
          <p className={`mt-0.5 text-sm font-bold tabular-nums text-gray-900 ${compact ? '' : 'sm:text-base'}`} data-id="element-198" data-mp="15h6a28z1vfv1">
            {column.value.toFixed(1)}
          </p>
        </div>)}
    </div>;
}
export function ReviewPillars({
  scores
}: {
  scores: PillarScores;
}) {
  return <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs font-semibold tabular-nums" data-id="element-199" data-mp="34j2kpvf0t8j6">
      <span className="text-gray-700" data-id="element-200" data-mp="2zlu0lpabaufa">
        Stock <span className="text-gray-900" data-id="element-201" data-mp="2uniqddg3uhwj">{scores.stock}/5</span>
      </span>
      <span className="text-amber-600" data-id="element-202" data-mp="2ukmudunti3aq">
        Wait <span className="text-gray-900" data-id="element-203" data-mp="2pmv0ww7iy94f">{scores.wait}/5</span>
      </span>
      <span className="text-gray-700" data-id="element-204" data-mp="2lm1gictajcga">
        Care <span className="text-gray-900" data-id="element-205" data-mp="2lmumhbkfdxxd">{scores.care}/5</span>
      </span>
    </div>;
}